export default __webpack_public_path__ + "static/media/locally-sourced-mobile@2x.307fc09f.jpg";